// Import functions from the 'helpers' module
import { find, findMany, on, addClass, removeClass, dataset } from '../helpers';

// Select relevant elements from the DOM
const dialogs = findMany('[data-dialog]');
const openBtns = findMany('[data-modal]');
const closeBtns = findMany('[data-close-dialog]');

// Constants for legacy browser handling
const legacyBrowserKey = 'legacy_browser_continue';
const legacyId = 'legacy-browser';

// Function to open a dialog
const openDialog = (element) => {
    // Determine the target dialog based on the data attribute or default to legacyId
    const target = element ? dataset(element, 'modal') : legacyId;
    const modal = find(`#${target}`);

    // Apply animations to show the dialog
    requestAnimationFrame(() => {
        removeClass(modal, ['opacity-0', 'invisible']);
        addClass(modal, ['opacity-100', 'visible']);
    });
};

// Function to close all dialogs
const closeDialog = () => {
    // Apply animations to hide all dialogs
    requestAnimationFrame(() => {
        dialogs.forEach(element => {
            removeClass(element, 'opacity-100');
            addClass(element, 'opacity-0');

            setTimeout(() => {
                removeClass(element, 'visible');
                addClass(element, 'invisible');
            }, 300);
        });
    });

    // Store a flag in sessionStorage for legacy browser check
    if (find(`#${legacyId}`)) {
        sessionStorage.setItem(legacyBrowserKey, 'true');
    }
};

// Function to handle loading of the page
const handleLoad = () => {
    // Check if the legacyBrowserKey flag is not set to 'true' in sessionStorage
    if (sessionStorage.getItem(legacyBrowserKey) !== 'true') {
        openDialog();
    }
};

// Add a load event listener to call handleLoad
if (find(`#${legacyId}`)) {
    on('load', handleLoad, window);
}

// Add click event listeners to open buttons
openBtns.forEach(element => {
    on('click', (event) => {
        event.preventDefault();
        openDialog(element);
    }, element, false);
});

// Add click event listeners to close buttons
closeBtns.forEach(element => {
    on('click', closeDialog, element);
});

// Add a keydown event listener to close dialogs when the 'Escape' key is pressed
on('keydown', element => {
    if (element.key === 'Escape') {
        closeDialog();
    }
}, document);
